import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

type Props = {
  title: string;
  url: string;
};

const ButtonWrapper = styled.div`
  min-height: 150px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  @media (max-width: 1024px) {
    min-height: 90px;
  }
`;

const ButtonLink = styled(Link)`
  display: block;
  text-decoration: none;
  text-align: center;
  background: #272137;
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 80px;
  height: 80px;
  width: auto;
  padding: 0 30px;
  border-radius: 40px;
  text-transform: uppercase;
  margin: 0 auto;
  transition: 0.3s;
  @media (max-width: 1024px) {
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
  }
  @media (max-width: 430px) {
    font-size: 14px;
    height: 45px;
    line-height: 45px;
  }
  :hover,
  :focus {
    background: #322b46;
    text-decoration: none;
    color: #fff;
  }
`;

export const Button = (props: Props) => {
  return (
    <ButtonWrapper>
      <ButtonLink to={props.url}>{props.title}</ButtonLink>
    </ButtonWrapper>
  );
};
